import { includes } from 'lodash';
import { createSelector } from 'reselect';
import compareVersions from 'compare-versions';
import { ONE_APP_VERSIONS } from '../constants/one-app-versions';
import { parseRouterData } from '../services/parse-router-data';
var getSearchParams = function (state) { return state.searchParams; };
export var getDeviceType = function (state) { return getSearchParams(state).deviceType || getSearchParams(state).devicetype; };
export var getIsMobile = function (state) { return getDeviceType(state) === 'mobile'; };
export var getIsDesktop = function (state) { return getDeviceType(state) === 'desktop'; };
export var getViewMode = function (state) { return getSearchParams(state).viewMode; };
export var getCompId = function (state) { return getSearchParams(state).origCompId || getSearchParams(state).compId; };
export var getExternalId = function (state) { return getSearchParams(state).externalId; };
export var getWidth = function (state) {
    var width = getSearchParams(state).width;
    return !width || width === '100%' ? 980 : parseInt(width, 10);
};
export var getRouterData = function (state) { return parseRouterData(getSearchParams(state).routerData); };
export var shouldRefreshApp = function (state) { return getSearchParams(state).refreshApp === 'true'; };
export var isOneApp = function (state) { return getSearchParams(state).oneApp === 'true'; };
export var shouldShowShare = function (state) { return !isOneApp(state); };
var VERSION_SEPARATOR = '.';
var normalizeVersionNumber = function (version) {
    if (version === void 0) { version = ''; }
    return version.split(VERSION_SEPARATOR).slice(0, 3).join(VERSION_SEPARATOR);
};
export var getOneAppVersion = createSelector(getSearchParams, function (searchParams) {
    return normalizeVersionNumber(searchParams.oneAppVersion);
});
var createIsSupportedSelector = function (targetVersion, targetCompareResults) {
    if (targetCompareResults === void 0) { targetCompareResults = [0, 1]; }
    return createSelector(getOneAppVersion, function (oneAppVersion) {
        return oneAppVersion ? includes(targetCompareResults, compareVersions(oneAppVersion, targetVersion)) : false;
    });
};
export var isOneAppImageUploadSupported = createIsSupportedSelector(ONE_APP_VERSIONS.IMAGE_UPLOAD);
export var isOneAppLinksSupported = createIsSupportedSelector(ONE_APP_VERSIONS.LINKS);
export var isOneAppShareSupported = createIsSupportedSelector(ONE_APP_VERSIONS.SHARE);
export var getOneAppPrimaryColor = function (state) { return getSearchParams(state).businessPrimaryColor; };
export var getPreviousPathname = function (state) { return getSearchParams(state).previousPathname; };
export var getSelectedLanguage = function (state) { return getSearchParams(state).lang; };
